const API_SERVER = {
    development: 'https://int.h5.ihgwechat.com.cn',
    production:'https://h5.ihgwechat.com.cn',
    qa:'https://staging.h5.ihgwechat.com.cn'
}[process.env.NODE_ENV]

const MTA_SERVER = {
	development: {
		sid: '500650822',
		cid: '500650823'
	},
	production: {
		sid: '500628667',
		cid: '500628669'
	},
	qa: {
		sid: '500650822',
		cid: '500650823'
	}
}[process.env.NODE_ENV]
export {
    API_SERVER,
    MTA_SERVER
}



// WEBPACK FOOTER //
// ./src/config/index.js